export default class SearchClearer {
    constructor(element) {
        this.trigger = typeof (element) === 'string' ? document.querySelector(element) : element;
        this.input = this.trigger.querySelector(('input[type="text"]'));
        this.crossButton = this.trigger.querySelector('button');
        this.submitButton = this.trigger.querySelector('button[type="submit"]');
        this.scopeValue = undefined;
        this.lastPropertyName = undefined;
    }
    init() {
        this.input.addEventListener('input', this.searchclearer.bind(this));
        this.crossButton.addEventListener('click', this.clearText.bind(this));
        this.input.addEventListener('load', this.pageLoad.bind(this));

        window.addEventListener("load", this.pageLoad.bind(this));
    }

    searchclearer(e) {
        if (e.target.value.length > 0)
            this.crossButton.style.display = 'block';
        else
            this.crossButton.style.display = 'none';
    }

    clearText() {
        this.crossButton.click();
        this.crossButton.style.display = 'none';

        if (!this.crossButton.className.includes("clear-not-submit") && this.input.attributes["ng-model"]) {
            let parts = this.input.attributes["ng-model"].value.split('.');
            this.lastPropertyName = parts[parts.length - 1];
            let scope = $(this.input).scope();
            this.scopeValue = scope;
            for (let i = 0; i < parts.length - 1; i++) {
                this.scopeValue = scope[parts[i]]; //this.scopeValue will hold last property object here
            }
            this.scopeValue[this.lastPropertyName] = undefined; //it will clear last property value
            scope.$apply(); //this tells angular to update all the bindings with the new data
            this.submitButton.click();
            this.input.focus();
        }
        else {
            this.input.value = '';
            this.input.focus();
        }
    }

    pageLoad() {
        if (this.input.value.length > 0)
            this.crossButton.style.display = 'block';
        else
            this.crossButton.style.display = 'none';
    }
}